var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8333 6.16671H7.83325V1.16671C7.83325 0.705874 7.45992 0.333374 6.99992 0.333374C6.53992 0.333374 6.16658 0.705874 6.16658 1.16671V6.16671H1.16659C0.706585 6.16671 0.333252 6.53921 0.333252 7.00004C0.333252 7.46087 0.706585 7.83337 1.16659 7.83337H6.16658V12.8334C6.16658 13.2942 6.53992 13.6667 6.99992 13.6667C7.45992 13.6667 7.83325 13.2942 7.83325 12.8334V7.83337H12.8333C13.2933 7.83337 13.6666 7.46087 13.6666 7.00004C13.6666 6.53921 13.2933 6.16671 12.8333 6.16671Z",
    fill: "#00A0F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/PlusIcon.46c4e6988a50ff52ae1537494e1dbc90.svg";
export { ForwardRef as ReactComponent };